import { Injectable } from "@angular/core";
import {
  AngularFirestore,
  AngularFirestoreCollection,
  DocumentReference
} from "@angular/fire/firestore";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { City } from "../models/city";
import { Venue } from "../models/venue";
import { HttpClient, HttpParams } from "@angular/common/http";
import * as firebase from "firebase";

export class CityApi {
  public collection: AngularFirestoreCollection<City>;
  constructor(public db: AngularFirestore, private httpClient: HttpClient) {
    this.collection = this.db.collection("devCities", ref =>
      ref.orderBy("city_name", "asc")
    );
  }

  get(docId: string): Observable<City> {
    return this.collection.doc<City>(docId).valueChanges();
  }

  getAll(): Observable<City[]> {
    return this.collection.snapshotChanges().pipe(
      map(actions => {
        return actions.map(action => {
          var data = action.payload.doc.data();
          const id = action.payload.doc.id;
          return { id, ...data };
        });
      })
    );
  }

  getVenuesForCity(city: City): Observable<Venue[]> {
    return this.collection
      .doc(city.city_name + " " + city.state)
      .collection<Venue>("Venues")
      .snapshotChanges()
      .pipe(
        map(venues => {
          return venues.map(venue => {
            var data = venue.payload.doc.data();
            const id = venue.payload.doc.id;
            return new Venue(data, id);
          });
        })
      );
  }

  async countActiveVenues(city: City): Promise<number> {
    var temp = 0;
    await this.db
      .collection("devCities")
      .doc(city.city_name + " " + city.state)
      .collection<Venue>("Venues")
      .ref.where("is_active", "==", true)
      .get()
      .then(async (data: firebase.firestore.QuerySnapshot<Venue>) => {
        temp = data.docs.length;
      });
    return temp;
  }

  async countActivePasses(venue: Venue) {
    var count = 0;
    await venue.city
      .collection("Venues")
      .doc(venue.id)
      .collection("Products")
      .where("is_active", "==", true)
      .get()
      .then(result => {
        count = result.docs.filter(doc => doc.data().is_active == true).length;
      });
    return count;
  }

  add(city: City): void {
    this.collection.doc(city.city_name + " " + city.state).set(city);
    return;
  }

  addVenue(city: City, venue: Venue): void {
    this.collection
      .doc(city.city_name + " " + city.state)
      .collection("Venues")
      .add(venue);
    return;
  }

  getNewVenue(city: City): Venue {
    return new Venue(
      {
        city: this.getDocumentReference(city),
        description: "",
        image: "",
        is_active: true,
        name: "",
        rank: 0,
        thumbnail: "",
        redirect: false,
        redirect_url: ""
      },
      ""
    );
  }

  update(city: City): void {
    this.collection.doc(city.city_name + " " + city.state).set(city);
    return;
  }

  updateVenueRank(city: City, venueid: string, rank: number) {
    this.getDocumentReference(city)
      .collection("Venues")
      .doc(venueid)
      .set({ rank: rank }, { merge: true });
  }

  getId = (city: City): string => city.city_name + " " + city.state;

  getDocumentReference = (city: City): DocumentReference =>
    this.db.collection("devCities").doc(city.city_name + " " + city.state).ref;

  async getGeopoint(
    city_name: string,
    state: string
  ): Promise<firebase.firestore.GeoPoint> {
    const params = new HttpParams()
      .set("address", city_name + ", " + state)
      .set("key", "AIzaSyDm4ZmSplQOgm3dGnkuP5S913i6tIdKQnI");

    var result: JSON = await this.httpClient
      .get<JSON>("https://maps.googleapis.com/maps/api/geocode/json?", {
        params
      })
      .toPromise();
    if (
      result["status"] == "ZERO_RESULTS" ||
      !result["results"]["0"]["formatted_address"].includes(
        `${city_name}, ${state}`
      )
    )
      return null;

    return new firebase.firestore.GeoPoint(
      result["results"]["0"]["geometry"]["location"]["lat"],
      result["results"]["0"]["geometry"]["location"]["lng"]
    );
  }

  async getTimezone(pt: firebase.firestore.GeoPoint): Promise<string> {
    const params = new HttpParams()
      .set("location", pt.latitude + "," + pt.longitude)
      .set("timestamp", firebase.firestore.Timestamp.now().seconds.toString())
      .set("key", "AIzaSyDml6F7u5BRtyAfeTQiJHKWacepzB01-ss");
    var result = await this.httpClient
      .get<JSON>("https://maps.googleapis.com/maps/api/timezone/json?", {
        params
      })
      .toPromise();
    return result["timeZoneId"];
  }

  public new(): City {
    return {
      city_name: "",
      state: "",
      image: "",
      is_active: true,
      coordinates: null,
      timezone: "",
      venues: [],
      active_venues: 0
    };
  }
}
